import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Tooltip } from 'antd'
import { MeetingStatus } from '../../types'
import { IconNames, Colors, FlexJustify } from '../../components/util/types'
import PerIcon from '../../components/custom_components/Icon'
import PerFlexRow from '../../components/custom_components/FlexRow'
import PerText from '../../components/custom_components/Text'

interface EmployeeMeetingStatusProps {
  firstName: string
  meetingStatus: MeetingStatus
  withText?: boolean
  employeePrepared: boolean
  justify?: FlexJustify
}
// Todo refactor to fetch data from server, define own dto
const EmployeeMeetingStatus: FC<EmployeeMeetingStatusProps> = ({ firstName, meetingStatus, withText, employeePrepared, justify }) => {
  const [t] = useTranslation()
  const statusNotYetPreparedByEmployee = meetingStatus === MeetingStatus.Draft && !employeePrepared
  const statusPrepared = (meetingStatus === MeetingStatus.Draft && employeePrepared) || meetingStatus === MeetingStatus.Prepared
  const statusPending = meetingStatus === MeetingStatus.PendingConfirmation
  const statusConfirmed = meetingStatus === MeetingStatus.Confirmed

  const employeeStatusIconName = (): IconNames => {
    let result: IconNames = 'info_stroke'
    if (statusNotYetPreparedByEmployee) {
      result = 'edit_stroke'
    } else if (statusPrepared) {
      result = 'edit_stroke'
    } else if (statusPending) {
      result = 'waiting_stroke'
    } else if (statusConfirmed) {
      result = 'check_stroke'
    }
    return result
  }

  const employeeStatusIconColor = (): Colors => {
    let result: Colors = 'secondary'
    if (statusNotYetPreparedByEmployee) {
      result = 'warning'
    } else if (statusPrepared) {
      result = 'success'
    } else if (statusPending) {
      result = 'secondary'
    } else if (statusConfirmed) {
      result = 'success'
    }
    return result
  }

  const employeeStatusTooltip = (firstName: string) => {
    if (statusNotYetPreparedByEmployee) {
      return firstName + t('appraisalMeetingStatus.prep')
    } else if (statusPrepared) {
      return firstName + t('appraisalMeetingStatus.prepFinished')
    } else if (statusPending) {
      return t('appraisalMeetingStatus.confirmPendingStart') + firstName + t('appraisalMeetingStatus.confirmPendingEnd')
    } else if (statusConfirmed) {
      return t('appraisalMeetingStatus.confirmed')
    }

    return 'no text found'
  }

  return (
    <>
      {!withText && (
        <Tooltip title={employeeStatusTooltip(firstName)}>
          <div style={{ width: '16px', margin: justify === 'start' ? '0px' : '0 auto' }}>
            <PerIcon name={employeeStatusIconName()} color={employeeStatusIconColor()} size={16} variant="decoration" />
          </div>
        </Tooltip>
      )}
      {withText && (
        <PerFlexRow direction="row" justify={justify} mt="xxs" align="middle" noWrap className="meetingTile--infoText">
          <PerIcon
            name={employeeStatusIconName()}
            color={employeeStatusIconColor()}
            size={16}
            variant="decoration"
            className="per-flexRow--fixed"
          />

          <PerText ml="xxs" mt="xxxxs" color={employeeStatusIconColor()} fontSize="s" className="per-flexRow--shrink">
            {employeeStatusTooltip(firstName)}
          </PerText>
        </PerFlexRow>
      )}
    </>
  )
}

export default EmployeeMeetingStatus
